const reIsUint = /^(?:0|[1-9]\d*)$/
export default reIsUint
